<template>
    <div>
        <el-card v-if="rightsContains('LIST_GAINS_BLANK')">
            <div slot="header">
                <el-form :inline="true">
                    <el-form-item><span style="font-weight: bolder">涨幅榜黑名单</span></el-form-item>
                    <el-form-item label="交易币种"><coin-select @value="setCoinGainsBlankStart"/></el-form-item>
                    <el-form-item label="锚定币种"><coin-select @value="setCoinGainsBlankEnd"/></el-form-item>
                    <el-form-item><el-button type="primary" @click="addGainBlank()">新增交易对</el-button></el-form-item>
                    <el-form-item><el-button type="success" @click="saveGainBlank()">保存</el-button></el-form-item>
                </el-form>
            </div>
            <el-checkbox-group v-model="currentGainsBlack">
                <el-checkbox v-for="pair in originalGainsBlack" :label="pair"/>
            </el-checkbox-group>
        </el-card>

        <el-card style="margin-top: 20px" v-if="rightsContains('LIST_POPULAR')">
            <div slot="header">
                <el-form :inline="true">
                    <el-form-item><span style="font-weight: bolder">人气榜单</span></el-form-item>
                    <el-form-item label="交易币种"><coin-select @value="setPopularStart"/></el-form-item>
                    <el-form-item label="锚定币种"><coin-select @value="setPopularEnd"/></el-form-item>
                    <el-form-item><el-button type="primary" @click="addPopular()">新增交易对</el-button></el-form-item>
                    <el-form-item><el-button type="success" @click="savePopularity()">保存</el-button></el-form-item>
                </el-form>
            </div>
            <el-checkbox-group v-model="currentPopular">
                <el-checkbox v-for="pair in originalPopular" :label="pair"/>
            </el-checkbox-group>
        </el-card>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {RIGHTS_TYPE} from "../../common/constant";
    import api from "./api";
    import coinSelect from "../../components/coinSelect";

    export default {
        name: "ListConf",
        data() {
            return {
                originalGainsBlack: [],
                originalPopular: [],
                currentGainsBlack: [],
                currentPopular: [],
                gainsBlackStart:'',
                gainsBlackEnd:'',
                popularStart:'',
                popularEnd:'',
            }
        },
        computed: {
            ...mapState(["userInfo", "userRights"])
        },
        components: {'coin-select': coinSelect},
        created() {
            if (this.rightsContains('LIST_GAINS_BLANK')) {
               this.getGainsBlackList();
            }
            if (this.rightsContains('LIST_POPULAR')) {
               this.getPopularityList();
            }
        },
        methods:{
            getGainsBlackList(){
                api.queryGainsBlackList().then(response =>{
                    this.originalGainsBlack = response.data;
                    this.currentGainsBlack = response.data;
                })
            },
            getPopularityList(){
                api.queryPopularityList().then(response =>{
                    this.originalPopular = response.data;
                    this.currentPopular = response.data;
                })
            },
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
            setCoinGainsBlankStart(val){this.gainsBlackStart = val},
            setCoinGainsBlankEnd(val){this.gainsBlackEnd = val},
            setPopularStart(val){this.popularStart = val},
            setPopularEnd(val) {this.popularEnd = val},
            addGainBlank(){
                let pair = this.gainsBlackStart + '_' + this.gainsBlackEnd;
                this.originalGainsBlack.push(pair);
                api.saveGainsBlankList({val : this.listToString(this.originalGainsBlack)}).then(() =>{
                    this.getGainsBlackList();
                    this.$message.success('新增成功');
                })
            },
            addPopular(){
                let pair = this.popularStart + '_' + this.popularEnd;
                this.originalPopular.push(pair);
                api.savePopularityList({val : this.listToString(this.originalPopular)}).then(() =>{
                    this.getPopularityList();
                    this.$message.success('新增成功');
                })
            },
            listToString(list){
                let val = '';
                for(let i in list) {
                    val = val + list[i] + ',';
                }
                return val;
            },
            saveGainBlank(){
                api.saveGainsBlankList({val : this.listToString(this.currentGainsBlack)}).then(() =>{
                    this.getGainsBlackList();
                    this.$message.success('保存成功');
                })
            },
            savePopularity(){
                api.savePopularityList({val : this.listToString(this.currentPopular)}).then(() =>{
                    this.getPopularityList();
                    this.$message.success('保存成功');
                })
            }
        }
    }
</script>

<style scoped>

</style>
